import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  list: {
    services: [],
  } as any,
  details: {} as any,
};

const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    createService: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    requestServices: (_state, _action: PayloadAction<{ page?: number; limit?: number }>) => undefined,
    saveServices: (state, action: PayloadAction<{ list: any }>) => {
      const { list } = action.payload;
      state.list = list;
    },
    requestService: (_state, _action: PayloadAction<{ id: any }>) => undefined,
    saveService: (state, action: PayloadAction<{ data: any }>) => {
      state.details = action.payload.data;
    },
    updateService: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    deleteService: (_state, _action: PayloadAction<any>) => undefined,

    resetservice: () => initialState,
  },
});

export default serviceSlice;
